module.exports = __webpack_public_path__ + "exo-latin-900.5f81c4362dcb692ed3d3.woff";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-900.woff
// module id = ../../../../typeface-exo/files/exo-latin-900.woff
// module chunks = styles